<script>
    import Form from 'vform';

    export default {
        layout: 'default',

        metaInfo () {
            return { title: this.$t('register') };
        },

        data: () => ({
            form: new Form({
                name: '',
                email: '',
                password: '',
                password_confirmation: ''
            })
        }),

        methods: {
            /**
             * @desc редирект на страницу с формой авторизации
             **/
            onSignInBtnClick() {
                this.$router.push({ name: 'login' })
            },

            async register () {
                // Register the user.
                const { data } = await this.form.post('/api/register');

                this.$notify({
                    group: 'global',
                    type: 'warn',
                    title: this.$t('account_verification'),
                    text: this.$t('account_verification_text')
                });

                // Log in the user.
                const { data: { token } } = await this.form.post('/api/login');

                // Save the token.
                this.$store.dispatch('saveToken', { token });

                // Update the user.
                await this.$store.dispatch('updateUser', { user: data });

                // Redirect home.
                this.$router.push({ name: 'user.profile' });
            }
        }
    }
</script>

<template>
    <div class="row registration">
        <div class="col-lg-8 m-auto">

            <h1 class="title">{{ $t('register') }}</h1>
            <h2 class="sub-title">{{ $t('register_subtitle') }}</h2>

            <form @submit.prevent="register" @keydown="form.onKeydown($event)">
                <!-- Name -->
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">{{ $t('name') }}</label>
                    <div class="col-md-7">
                        <input v-model="form.name"
                               type="text"
                               name="name"
                               :placeholder="$t('name_placeholder')"
                               class="form-control"
                               :class="{ 'is-invalid': form.errors.has('name') }">
                        <has-error :form="form" field="name"></has-error>
                    </div>
                </div>

                <!-- Email -->
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">{{ $t('email') }}</label>
                    <div class="col-md-7">
                        <input v-model="form.email"
                               type="email"
                               name="email"
                               :placeholder="$t('email_placeholder')"
                               class="form-control"
                               :class="{ 'is-invalid': form.errors.has('email') }">
                        <has-error :form="form" field="email"></has-error>
                    </div>
                </div>

                <!-- Password -->
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">{{ $t('password') }}</label>
                    <div class="col-md-7">
                        <input v-model="form.password"
                               type="password"
                               name="password"
                               class="form-control"
                               :class="{ 'is-invalid': form.errors.has('password') }">
                        <has-error :form="form" field="password"></has-error>
                    </div>
                </div>

                <!-- Password Confirmation -->
                <div class="form-group row">
                    <label class="col-md-3 col-form-label text-md-right">{{ $t('confirm_password') }}</label>
                    <div class="col-md-7">
                        <input v-model="form.password_confirmation"
                               type="password"
                               name="password_confirmation"
                               class="form-control"
                               :class="{ 'is-invalid': form.errors.has('password_confirmation') }">
                        <has-error :form="form" field="password_confirmation"></has-error>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="form-group row button-wrapper">
                    <div class="col-md-9 ml-md-auto">
                        <v-button :loading="form.busy">{{ $t('register') }}</v-button>
                        <v-button :loading="form.busy" type="link" native-type="button" @click="onSignInBtnClick">{{ $t('or_sign_in') }}</v-button>
                    </div>
                </div>
            </form>


        </div>
    </div>
</template>





// WEBPACK FOOTER //
// resources/assets/js/pages/auth/register.vue